<template>
  <div>
    <b-button v-if="(userData.user_role === 'USERROLE11111' || userData.user_role === 'USERROLE11118')" class="notification-btn position-relative" @click="handleShowNotificationModal" title="Notifications">
      <i class="ri-notification-fill notification-icon"></i>
      <span v-if="notificationCount && notificationCount > 0" class="notification-badge">
        {{ notificationCount > 99 ? "99+" : notificationCount }}
      </span>
    </b-button>

    <!-- modal -->
     <b-modal
      v-model="showNotificationsModal"
      title="Notifications"
      size="xl"
      scrollable
      centered
      modal-class="notification-modal"
      no-close-on-backdrop
      @hide="handleCloseModal"
    >
      <b-row>
        <iq-card class="col-12" style="padding:20px 10px; margin-bottom: 25px;">
          <div class="d-flex flex-column flex-lg-row align-items-center col-12">
            <!-- date picker -->
            <div class="dateRange col-12 col-lg-6 pl-lg-2">
              <b-col class="w-100 p-0">
                <date-range-picker opens="right" class="w-100" ref="picker" :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"  v-model="whereFilter.dateRange" @update="handleDateRangeApply"></date-range-picker>
              </b-col>
            </div>
            <!-- date picker -->
            <!-- Backend Search -->
            <div class="col-12 col-lg-6 pb-2 pb-lg-0">
              <b-form-input class="form-control"
                @input="searchAdminNotification"
                v-model="whereFilter.search_param"
                type="search"
                :placeholder="cvSearchText"></b-form-input>
            </div>
            <!-- Backend Search -->
          </div>
        </iq-card>
        <iq-card class="col-12" style="padding:20px;">
          <template class="col-12" v-slot:body>
            <div style="min-height: 400px;" v-if="notificationsList && Array.isArray(notificationsList) && notificationsList.length > 0">
              <div class="iq-accordion career-style notification-style" v-for="(notification, index) of notificationsList" :key="index">
                <div :class="notification.notification_seen_status[userData.user_id] == 1 ? 'bg-light' : 'bg-white'" class="iq-card iq-accordion-block">
                  <!-- notification title -->
                  <div class="active-notification clearfix pointer d-flex justify-content-between align-items-center" @click="toggleAccordion(index, notification)">
                    <div class="col-sm-11">
                      <div :class="notification.notification_seen_status[userData.user_id] == 1 ? 'font-weight-normal' : 'font-weight-bold'">
                        <div class="notification-title d-flex align-items-center">
                          <!-- bullet -->
                          <span :class="notification.notification_seen_status[userData.user_id] == 1 ? 'bg-secondary': 'bg-primary'" class="notification-dot mr-2"></span>
                          <!-- bullet -->
                          <span v-html="notification.notification_title"></span>
                        </div>
                        <span class="notification-time">
                          <i class="ri-time-line mr-1"></i>
                          {{ notification.created_on | dateFormatDDMMMYYYYHHMMA }}
                        </span>
                      </div>
                    </div>

                    <!-- icon -->
                    <div class="accordion-icon">
                      <i :class="[activeAccordion === index ? 'ri-subtract-line' : 'ri-add-line', notification.notification_seen_status[userData.user_id] == 1 ? 'text-secondary' : 'text-primary']"></i>
                    </div>
                  </div>

                  <!-- notification desc -->
                  <transition name="accordion">
                    <div class="accordion-details" v-if="activeAccordion === index">
                      <div class="mb-0 p-0" v-html="notification.notification_desc"></div>
                    </div>
                  </transition>
                </div>
              </div>
              <b-col v-if="notificationsList && notificationsList.length > 0 && (currentBatchNo * dataPerPage) < totalNotificationsCount" sm="12" md="12" class="py-3">
                <b-row>
                  <b-col sm="12" md="7">
                    <b-btn variant="primary" @click="loadMoreData">Load More</b-btn>
                  </b-col>
                </b-row>
              </b-col>
            </div>
            <div v-else-if="notificationsList && Array.isArray(notificationsList) && notificationsList.length === 0" class="text-center py-5" style="min-height: 250px;">
              <h5 class="mt-3 mb-1 text-secondary">No Notifications Found</h5>
            </div>
            <div v-else class="text-center py-5">
              <b-spinner variant="primary" class="align-middle"></b-spinner>
              <h5 class="mt-3 text-primary">Loading Notifications...</h5>
              <p class="text-muted mb-0">Please wait while we fetch your notifications.</p>
            </div>
          </template>
        </iq-card>
      </b-row>

      <!-- Modal Footer -->
      <template #modal-footer="">
        <b-button size="sm" @click="handleCloseModal">
          Cancel
        </b-button>
      </template>
    </b-modal>
    <!-- modal -->
    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </div>
</template>

<script>
import moment from "moment"
import { AdminNotifications } from "../../../FackApi/api/AdminNotification"

export default {
  name: "NotificationsModal",
  props: {
    propNotificationObj: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      showNotificationsModal: false,
      notificationCount: null,
      activeAccordion: null,
      notificationsList: null,
      whereFilter: {
        search_param: "",
        dateRange: {
          startDate: moment().subtract(1, "month"),
          endDate: moment()
        }
      },
      currentBatchNo: 1,
      dataPerPage: 25,
      showToast: false,
      toastTitle: "Notifications",
      toastMsg: null,
      toastVariant: "default",
      totalNotificationsCount: 0,
      cvSearchText: "Type to search"
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  methods: {
    /**
     * handleShowNotificationModal
     */
    handleShowNotificationModal () {
      this.showNotificationsModal = true
      this.adminNotificationList(this.propNotificationObj)
    },
    /**
     * toggleAccordion
     */
    toggleAccordion (index, notificationObj) {
      let currentActiveAccordian = this.activeAccordion
      this.activeAccordion = currentActiveAccordian === index ? null : index

      // if notification is currently unread for the participant update notification status to seen
      if (currentActiveAccordian !== index && notificationObj.notification_seen_status[this.userData.user_id] == 0) {
        let editNotificationPayload = { ...this.propNotificationObj }
        editNotificationPayload.notification_id = notificationObj.notification_id
        editNotificationPayload.update_notification_seen_status = true
        this.adminNotificationEdit(editNotificationPayload)
      }
    },
    /**
     * adminNotificationList
     */
    async adminNotificationList (payload, loadViaLoadMore = false) {
      try {
        // setting data for pagination
        this.whereFilter.currentBatchNo = this.currentBatchNo
        this.whereFilter.dataPerPage = this.dataPerPage
        payload.whereFilter = this.whereFilter

        let adminNotificationListResp = await AdminNotifications.adminNotificationList(this, payload)
        if (adminNotificationListResp && adminNotificationListResp.resp_status && adminNotificationListResp?.resp_data?.data?.length > 0) {
          if (!loadViaLoadMore) {
            this.notificationsList = [ ...adminNotificationListResp.resp_data.data ]
          }
          else {
            this.notificationsList = [ ...this.notificationsList, ...adminNotificationListResp.resp_data.data ]
          }

          // Parse notification_seen_status JSON string into object
          if (this.notificationsList && Array.isArray(this.notificationsList)) {
            this.notificationsList = this.notificationsList.map(item => ({ ...item, notification_seen_status: item.notification_seen_status && typeof item.notification_seen_status === "string" ? JSON.parse(item.notification_seen_status) : {} }))
          }

          // total data for load more
          this.totalNotificationsCount = adminNotificationListResp.resp_data_total_count
        }
        else {
          this.showLoadMoreBtn = false
          this.toastMsg = adminNotificationListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
          this.notificationsList = []
        }
      }
      catch (err) {
        this.notificationsList = []
        this.toastTitle = "Notifications"
        this.toastMsg = "Something went wrong while fetching notifications."
        this.toastVariant = "danger"
        this.showToast = true
        console.error("Exception occurred at adminNotificationList() and Exception:", err)
      }
    },
    /**
     * adminNotificationCount
     */
    async adminNotificationCount (payload) {
      try {
        let adminNotificationCountResp = await AdminNotifications.adminNotificationCount(this, payload)
        if (adminNotificationCountResp.resp_status) {
          this.notificationCount = adminNotificationCountResp.resp_data.data[0].total_count
        }
        else {
          this.notificationCount = null
        }
      }
      catch (err) {
        this.notificationCount = null
        console.error("Exception occurred at adminNotificationCount() and Exception:", err)
      }
    },
    /**
     * loadMoreData
     */
    async loadMoreData () {
      this.currentBatchNo = this.currentBatchNo + 1
      this.adminNotificationList(this.propNotificationObj, true)
    },
    /**
     * handleDateRangeApply
     */
    handleDateRangeApply () {
      this.currentBatchNo = 1

      this.adminNotificationList(this.propNotificationObj, false)
    },
    /**
     * handleCloseModal
     */
    handleCloseModal () {
      this.showNotificationsModal = false
      this.activeAccordion = null
      this.notificationsList = null
      this.currentBatchNo = 1
      this.whereFilter = {
        search_param: "",
        dateRange: {
          startDate: moment().subtract(1, "month"),
          endDate: moment()
        }
      }
      this.adminNotificationCount(this.propNotificationObj)
    },
    /**
     * searchAdminNotification
     */
    searchAdminNotification () {
      if (this.whereFilter.search_param && this.whereFilter.search_param.length > 2) {
        this.adminNotificationList(this.propNotificationObj)
      }
      else if (!this.whereFilter.search_param || this.whereFilter.search_param.length === 0) {
        this.adminNotificationList(this.propNotificationObj)
      }
    },
    /**
     * adminNotificationEdit
     */
    async adminNotificationEdit (payload) {
      try {
        let adminNotificationEditResp = await AdminNotifications.adminNotificationEdit(this, payload)
        if (adminNotificationEditResp && adminNotificationEditResp.resp_status) {
          let seenUserId = payload.gide_user_id || payload.counsellorId

          this.notificationsList.forEach(item => {
            // update only selected notification
            if (item.notification_id === payload.notification_id) {
              // parse JSON if string
              if (item.notification_seen_status && typeof item.notification_seen_status === "string") {
                item.notification_seen_status = item.notification_seen_status ? JSON.parse(item.notification_seen_status) : {}
              }
              // mark as seen
              item.notification_seen_status[seenUserId] = 1
            }
          })
        }
      }
      catch (err) {
        console.error("Exception occurred at adminNotificationEdit() and Exception:", err.message)
      }
    }
  },
  watch: {
    propNotificationObj: {
      immediate: true,
      deep: true,
      handler (newVal) {
        if (newVal && Object.keys(newVal).length && (this.userData.user_role === "USERROLE11111" || this.userData.user_role === "USERROLE11118")) {
          this.adminNotificationCount(newVal)
        }
      }
    }
  }
}
</script>

<style scoped>
.notification-btn {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  padding: 6px 10px;
}
.notification-icon {
  font-size: 25px;
  color: var(--iq-primary);
}
.notification-badge {
  position: absolute;
  top: 0px;
  right: 2px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--iq-primary);
  color: white;
  font-size: 10px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  border: 2px solid white;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
}
.iq-accordion-block {
  border: 1px solid #f1f1f1 !important;
  margin-bottom: 10px !important;
  padding: 20px !important;
  border-radius: 10px;
  transition: all 0.2s ease;
}
.iq-accordion-block:hover {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
}

.notification-title {
  font-size: 17px;
  color: #222;
  line-height: 1.4;
}

.notification-time {
  margin-top: 4px;
  font-size: 12px;
  color: #8a8a8a;
  display: flex;
  align-items: center;
  line-height: 1;
}
.accordion-details {
  padding-top: 12px;
  color: #555;
  line-height: 1.6;
}
.accordion-details p {
  margin-bottom: 0;
  margin-top: 10px;
}
.accordion-icon {
  min-width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.accordion-icon i {
  font-size: 22px;
  transition: transform 0.25s ease;
}

/* accordion animation */
.accordion-enter-active,
.accordion-leave-active {
  overflow: hidden;
  transition:
    max-height 0.3s ease,
    opacity 0.3s ease,
    transform 0.3s ease;
}
.accordion-enter,
.accordion-leave-to {
  max-height: 0;
  opacity: 0;
  transform: translateY(-6px);
}
.accordion-enter-to,
.accordion-leave {
  max-height: 500px;
  opacity: 1;
  transform: translateY(0);
}

/* optional better footer */
.notification-modal .modal-footer {
  border-top: 1px solid #f1f1f1;
}

/* scrollbar */
.notification-modal .modal-body::-webkit-scrollbar {
  width: 6px;
}
.notification-modal .modal-body::-webkit-scrollbar-thumb {
  background: #cfcfcf;
  border-radius: 10px;
}
.notification-modal .modal-body::-webkit-scrollbar-track {
  background: transparent;
}
.notification-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  min-width: 8px;
}
</style>
